
import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { XCircle, PawPrint } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { useTranslation } from 'react-i18next';

const PaymentCancel = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason') || 'unknown';

  return (
    <div className="min-h-screen bg-muted/30 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="h-10 w-10 text-red-600" />
          </div>
          <CardTitle className="text-2xl font-bold text-foreground">
            {t('payment.cancel.title')}
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-muted-foreground">
            {t('payment.cancel.noCharges')}
          </p>
          
          <div className="bg-blue-50 dark:bg-blue-950/30 p-4 rounded-lg">
            <p className="text-sm text-blue-800 dark:text-blue-200">
              <strong>{t('payment.cancel.dontWorry')}</strong> {t('payment.cancel.tryAgainMessage')}
            </p>
          </div>
          
          <div className="space-y-2">
            <Link to="/subscription" className="block">
              <Button className="w-full bg-primary hover:bg-primary/90">
                {t('payment.cancel.tryAgain')}
              </Button>
            </Link>
            <Link to="/feed" className="block">
              <Button variant="outline" className="w-full">
                <PawPrint className="h-4 w-4 mr-2" />
                {t('payment.cancel.backToDashboard')}
              </Button>
            </Link>
          </div>
          
          <p className="text-xs text-muted-foreground">
            {t('payment.cancel.contactSupport')}
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
